import "core-js/modules/es.function.name.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "RadioButton",
  inheritAttrs: false,
  props: {
    label: {
      type: [String, Boolean],
      required: true
    },
    isChecked: {
      type: Boolean
    }
  },
  emits: ["change"],
  methods: {
    emitChange: function emitChange() {
      this.$emit("change", {
        id: this.$attrs.id,
        label: this.label,
        name: this.$attrs.name
      });
    },
    handleClick: function handleClick() {
      var checkboxBtn = this.$refs.checkbox;
      checkboxBtn.checked = !checkboxBtn.checked;
      this.emitChange();
    },
    handleOnInput: function handleOnInput() {
      this.emitChange();
    }
  }
});